import React from 'react';
import PropTypes from 'prop-types'
import { StyledRowAwards } from './StyledRowAwards';

const RowAwards = ({ awardTitle, awards}) => {
  return (
    <React.Fragment>
      {
        <StyledRowAwards>
          <h5 className="big--title">{awardTitle}</h5>
          {
            awards.map((key, i) => {
              return <p key={i} className="preset-10 award--name">{key}</p>
            })
          }
          
        </StyledRowAwards>
      }
    </React.Fragment>
  );
};

RowAwards.propTypes = {
  awards: PropTypes.array
};

RowAwards.defaultProps = {
  tag: "div",
  awards: []
};

export default RowAwards;
